import { render, staticRenderFns } from "./DarkBrandLogo.vue?vue&type=template&id=3837303a&scoped=true&"
import script from "./DarkBrandLogo.vue?vue&type=script&lang=js&"
export * from "./DarkBrandLogo.vue?vue&type=script&lang=js&"
import style0 from "./DarkBrandLogo.vue?vue&type=style&index=0&id=3837303a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3837303a",
  null
  
)

export default component.exports